// Hero.js
import React, { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

export default function Hero() {
  const [init, setInit] = useState(false);

  // This should be run only once per application lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container) => {
    console.log("Particles container loaded", container);
  };

  const options = {
    background: {
      color: {
        value: "transparent",
      },
    },
    fullScreen: { 
      enable: false // This is critical - prevents particles from being fullscreen
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "grab",
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 140,
          links: {
            opacity: 0.5
          }
        },
      },
    },
    particles: {
      color: {
        value: "#ffffff",
      },
      links: {
        color: "#ffffff",
        distance: 150,
        enable: true,
        opacity: 0.3,
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 1,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 80,
      },
      opacity: {
        value: 0.5,
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 3 },
      },
    },
    detectRetina: true,
  };

  return (
    <div id="hero-section" className="text-center p-5 bg-gradient-primary position-relative" style={{ height: 'auto', minHeight: '500px', overflow: 'hidden' }}>
      {/* Container for particles with explicit dimensions */}
      {init && (
        <div className="particles-container" style={{ 
          position: 'absolute', 
          left: 0, 
          top: 0, 
          width: '100%', 
          height: '100%', 
          overflow: 'hidden',
          pointerEvents: 'none'
        }}>
          <Particles
            id="tsparticles"
            className="particles-canvas"
            particlesLoaded={particlesLoaded}
            options={options}
            style={{ 
              position: 'absolute',
              width: '100%',
              height: '100%'
            }}
          />
        </div>
      )}
      
      <div className="container position-relative" style={{ zIndex: 5 }}>
        {/* Name first, above professional titles */}
        <h1 className="display-4 fw-bold text-white mb-3">Efraim Hdz</h1>
        
        <h2 className="fw-bold text-white mb-4">AI Engineer | Software Engineer | Technologist</h2>
        
        <p className="lead fst-italic text-white mb-5">
          Engineering innovative solutions at the intersection of AI, software development, and emerging technologies.
        </p>
        
        <div className="d-flex justify-content-center mt-4">
          <a href="https://github.com/EfraHdz-git" className="btn btn-outline-light mx-2">
            <i className="bi bi-github me-1"></i> GitHub
          </a>
          <a href="https://www.linkedin.com/in/efraim-hernandez-a842431b0/" className="btn btn-outline-light mx-2">
            <i className="bi bi-linkedin me-1"></i> LinkedIn
          </a>
        </div>
      </div>
    </div>
  );
}